import { useState } from 'react';
import { faqs } from '@/mocks/faqs';

export default function FaqSection() {
  const [openId, setOpenId] = useState<string | null>(faqs[0]?.id ?? null);

  return (
    <section className="w-full bg-background-100 py-14 md:py-20">
      <div className="max-w-content mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 md:gap-12">
          <div className="lg:col-span-1">
            <p className="text-xs tracking-[0.2em] text-primary-600 font-medium mb-2 uppercase">
              FAQ / 常见问题
            </p>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
              关于看料社，你可能想知道
            </h2>
            <p className="mt-3 text-sm md:text-base text-foreground-600 leading-relaxed">
              这里是大家最常问到的问题。如果还有疑问，欢迎通过页面底部邮箱联系我们。
            </p>
          </div>

          <div className="lg:col-span-2">
            <div className="flex flex-col gap-3">
              {faqs.map((f) => {
                const open = openId === f.id;
                return (
                  <div
                    key={f.id}
                    className="rounded-lg border border-background-200 bg-background-50 overflow-hidden"
                  >
                    <button
                      type="button"
                      onClick={() => setOpenId(open ? null : f.id)}
                      className="w-full flex items-center justify-between gap-4 p-5 text-left cursor-pointer"
                      aria-expanded={open}
                    >
                      <span className="font-heading text-base md:text-lg font-bold text-foreground-950">
                        {f.question}
                      </span>
                      <i
                        className={`shrink-0 text-foreground-500 text-xl transition-transform ${
                          open ? 'ri-subtract-line' : 'ri-add-line'
                        }`}
                      />
                    </button>
                    {open && (
                      <div className="px-5 pb-5 -mt-1">
                        <p className="text-sm text-foreground-600 leading-relaxed">{f.answer}</p>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}